import {z} from 'zod';

import {
  advertisingAdapterErrorCodeSchema,
  advertisingJobStatusSchema,
  advertisingProgressSchema,
} from './AdvertisingCommonSchemas';

export const advertisingJobStatusResponseSchema = z.object({
  jobId: z.string().uuid(),
  status: advertisingJobStatusSchema,
  publicationId: z.string().uuid().nullable(),
  externalId: z.string().nullable(),
  linkToAd: z.string().nullable(),
  errorCode: advertisingAdapterErrorCodeSchema.nullable(),
  errorMessage: z.string().nullable(),
  progress: advertisingProgressSchema.nullable(),
});

export type AdvertisingJobStatusResponse = z.infer<typeof advertisingJobStatusResponseSchema>;
